import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    id: '',
    name: '',
    project_type: '',
    steps: [],
}

const selectedProjectSlice = createSlice({
    name: 'selectedProject',
    initialState,
    reducers: {

        setSelectedProject: (state, action) => {
            const { id, name, project_type, steps } = action.payload
            state.id = id;
            state.name = name;
            state.project_type = project_type;
            state.steps = steps
            
            console.log("state.project:", state)
        },

        resetSelectedProject: (state, action) => {
            state.id = '';
            state.name = '';
            state.project_type = '';
            state.steps = [];
        }
    }
})

export const { setSelectedProject, resetSelectedProject } = selectedProjectSlice.actions

export default selectedProjectSlice.reducer